import { useAppSelector } from "../../hooks/StoreHooks";

export const useAllPermissions = () =>
  useAppSelector((state) => state.permissions.allPermissions);

export const useUserPermissions = (userId: string) =>
  useAppSelector((state) => state.permissions.userPermissions[userId] || []);

export const useCurrentUserPermissionList = () =>
  useAppSelector((state) => state.permissions.currentUserPermissionList);

export const useUserHasPermission = (userId: string, requiredPermission: string): boolean => {
  const permissions = useUserPermissions(userId);
  return permissions.some((p) => p.permissionName === requiredPermission);
};

export const useUserHasPermissions = (userId: string, required: string[]) => {
  const permissions = useUserPermissions(userId);
  const permissionNames = new Set(permissions.map((p) => p.permissionName));
  return required.every((p) => permissionNames.has(p));
};